module.exports = __webpack_public_path__ + "img/box9-09.e5cbf107.png";